import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Divider
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ConfirmationDialog = ({
    open,
    onClose,
    onConfirm,
    title,
    message,
    type = "warning", // "danger", "info", "warning"
    confirmText = "Confirm",
    cancelText = "Cancel",
    loading = false
}) => {
    return (
        <Dialog
            open={open}
            onClose={!loading ? onClose : undefined}
            maxWidth="xs"
            fullWidth
            sx={{
                "& .MuiDialog-paper": {
                    borderRadius: 3,
                    padding: "12px 24px",
                },
            }}
        >
            <DialogTitle
                sx={{
                    color: "#000",
                    fontWeight: 700,
                    fontSize: "18px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "16px 0",
                    borderBottom: "1px solid #E1E8ED",
                    fontFamily: "Inter",
                }}
            >
                {title}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 20,
                        height: 20,
                        border: "2px solid #444",
                        cursor: loading ? "not-allowed" : "pointer",
                        borderRadius: "6px",
                        opacity: loading ? 0.5 : 1,
                    }}
                    onClick={!loading ? onClose : undefined}
                >
                    <CloseIcon sx={{ fontSize: "14px", color: "#444" }} />
                </div>
            </DialogTitle>

            <Divider />

            <DialogContent sx={{ px: 0, py: 3 }}>
                <Typography
                    variant="body1"
                    sx={{
                        color: "#6A677E",
                        lineHeight: 1.5,
                        fontFamily: "Inter",
                        fontSize: "16px",
                        textAlign: "center",
                    }}
                >
                    {message}
                </Typography>
            </DialogContent>

            <DialogActions
                sx={{
                    px: 0,
                    pt: 3,
                    borderTop: "1px solid #E1E8ED",
                    gap: 1,
                    justifyContent: "flex-end",
                }}
            >
                <button
                    className="custom_btn secondary"
                    onClick={onClose}
                    disabled={loading}
                >
                    {cancelText}
                </button>
                <button
                    className={`custom_btn ${type === "danger" ? "danger" : "primary"}`}
                    onClick={onConfirm}
                    disabled={loading}
                >
                    {loading ? "Processing..." : confirmText}
                </button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
